import { Sale } from "@/models/base";
import { IShippingMethod } from "@/services/sendcloud-service";
import { Label } from "./label";

export class Parcel{
	id:number = 0;
	shipment:IShippingMethod = {id: 0, name: ""}
	name:string = "";
	company_name:string = "";
	address:string = "";
	address_2:string = "";
	house_number:string = "";
	city:string = "";
	postal_code:string = "";
	telephone:string = "";
	email:string = "";
	country:string = "";
	weight:string = "";
	label:Label | null = null;


	public constructor(data?:any){
		if (!data) return;
		this.id = data.id;
		this.shipment = data.shipment;
		this.name = data.name;
		this.company_name = data.company_name;
		this.address = data.address;
		this.address_2 = data.address_2;
		this.house_number = data.house_number;
		this.city = data.city;
		this.postal_code = data.postal_code;
		this.telephone = data.telephone;
		this.email = data.email;
		this.country = data.country;
		this.weight = data.weight;
		this.label = new Label(data.label);
	}

	public setDataFromSale(sale:Sale) {
		let address = sale.DeliveryAddress;
		if (!address || address.ID == 0) {
			address = sale.InvoiceAddress;
		}
		if (!address) return;
		this.name = address.FullName;
		this.company_name = address.CompanyName || "";
		this.address = address.AddressLine1;
		this.address_2 = address.AddressLine2;
		this.city = address.City;
		this.postal_code = address.Postal;
		this.telephone = address.Phone;
		this.email = address.Email;
		this.country = address.CountryCode || "BE";
	}

	public openInSendcloud(){
		window.open(`https://app.sendcloud.com/v2/shipping/${this.id}/details`);
	}
}